// extracted by mini-css-extract-plugin
export default {"root":"C3TJv","start-icon":"C0+n0","disabled":"_4NgIW","neutral":"_4eF2N","dark":"b2tw1","light":"get5j"};